// extracted by mini-css-extract-plugin
module.exports = {"left":"chatMenuItem_left__6lZME","listItem":"chatMenuItem_listItem__LBMVp","icon":"chatMenuItem_icon__1TJx5"};